import React from 'react';
import { useTheme } from '../context/ThemeContext';
import css from './ThemeButton.module.css';

export const ThemeButton: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  return (
    <button className={css.button} onClick={toggleTheme} aria-label="Переключить тему">
      <span aria-hidden="true">{theme === 'dark' ? '☀' : theme === 'second-light' ? '◐' : '☾'}</span>
    </button>
  );
};
